export default __webpack_public_path__ + "static/media/270.120e3a9f.jpg";